var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imageTypeFolder",style:({'background-image':'url(' + _vm.background + ')'})},[_c('p',{staticClass:"imageTypeFolder-title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }